// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lL-z","isFullWidth":"mL-z","landingPageVideo":"nL-z","play":"oL-z","iframeVideo":"pL-z","playHidden":"qL-z","fullwidth":"rL-z"};